import { useState, useEffect, useCallback } from "react";

const RESEND_COOLDOWN = 60;
const MAX_RESENDS = 3;

export function useResendTimer() {
  const [countdown, setCountdown] = useState(RESEND_COOLDOWN);
  const [resendCount, setResendCount] = useState(0);
  const canResend = countdown === 0 && resendCount < MAX_RESENDS;
  const maxResendsReached = resendCount >= MAX_RESENDS;

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const triggerResend = useCallback(() => {
    setResendCount((prev) => prev + 1);
    setCountdown(RESEND_COOLDOWN);
  }, []);

  const reset = useCallback(() => {
    setCountdown(RESEND_COOLDOWN);
    setResendCount(0);
  }, []);

  return { countdown, canResend, resendCount, maxResendsReached, maxResends: MAX_RESENDS, triggerResend, reset };
}
